import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import clsx from 'clsx';
import Icon from '../Icon/Icon';
import type { BreakpointAspectRatioConfigs } from '../LegacyPicture/image-transformer/types';
import LegacyPicture from '../LegacyPicture/LegacyPicture';
import styles from './ContactPerson.module.scss';
import type { ContactPersonProps } from './interfaces';

const socialTypeToIcon = {
  Twitter: 'action/twitter',
  Linkedin: 'action/linkedin',
  Xing: 'action/xing',
} as const;

const SQUARE_BREAKPOINT_ASPECT_RATIO_CONFIGS: BreakpointAspectRatioConfigs = [
  {
    breakpoint: BreakPoint.XSS,
    aspectRatio: '1:1',
    width: 128,
  },
];

const ContactPerson = ({
  image,
  name,
  jobTitle,
  mail,
  phone,
  socials,
  pronouns,
}: ContactPersonProps) => {
  return (
    <div className={styles.base}>
      <div className={styles.pictureWrapper}>
        <LegacyPicture
          breakpointAspectRatioConfigs={SQUARE_BREAKPOINT_ASPECT_RATIO_CONFIGS}
          asset={image}
          className={styles.picture}
          fitCover
        />
        {socials
          ?.filter(({ link }) => link)
          .map((social) => {
            const position =
              social?.type === 'Linkedin' && socials.length !== 1
                ? 'left'
                : 'right';

            return (
              <a
                key={social.link}
                className={clsx(styles.social, styles[position], {
                  [styles.twitter]: social.type === 'Twitter',
                  [styles.linkedin]: social.type === 'Linkedin',
                  [styles.xing]: social.type === 'Xing',
                })}
                href={social.link}
                target="_blank"
                rel="noreferrer"
                aria-label={social.type}
              >
                <Icon
                  className={styles.socialIcon}
                  variant={socialTypeToIcon[social.type]}
                  size="iconSize24"
                />
              </a>
            );
          })}
      </div>
      <div className={styles.person}>
        <div>
          <span className={styles.name}>
            {name}
            {pronouns && <em> ({pronouns})</em>}
          </span>
          {jobTitle && <span className={styles.jobTitle}>{jobTitle}</span>}
        </div>

        {Boolean(mail || phone) && (
          <div className={styles.links}>
            {mail && (
              <a href={`mailto:${mail}`} className={styles.linkMail}>
                E-Mail senden
              </a>
            )}
            {phone && (
              <a href={`tel:${phone}`} className={styles.link}>
                {phone}
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactPerson;
